"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

const Plausible404Tracker = () => {
  const pathname = usePathname();

  useEffect(() => {
    const timer = setTimeout(() => {
      const plausible = (
        window as Window & { plausible?: (event: string, opts: { props: Record<string, string> }) => void }
      ).plausible;
      plausible?.("404", { props: { path: pathname } });

      // Log the 404 event to the console for debugging purposes
      console.info(`Plausible 404 event sent for path: ${pathname}`);
      console.info("Plausible : ", plausible);
    }, 2000);

    return () => clearTimeout(timer);
  }, [pathname]);

  return null;
};

export default Plausible404Tracker;
